import React from 'react';
import { motion } from 'framer-motion';
import { LayoutGrid, Briefcase, ShieldCheck, Sparkles, Clock, MapPin } from 'lucide-react';
const benefits = [{
  icon: <LayoutGrid className="w-6 h-6" data-id="element-45" />,
  title: 'Todo organizado en un solo lugar'
}, {
  icon: <Briefcase className="w-6 h-6" data-id="element-46" />,
  title: 'Fácil de transportar'
}, {
  icon: <ShieldCheck className="w-6 h-6" data-id="element-47" />,
  title: 'Materiales resistentes'
}, {
  icon: <Sparkles className="w-6 h-6" data-id="element-48" />,
  title: 'Diseño hermoso y premium'
}, {
  icon: <Clock className="w-6 h-6" data-id="element-49" />,
  title: 'Ahorra tiempo al trabajar'
}, {
  icon: <MapPin className="w-6 h-6" data-id="element-50" />,
  title: 'Perfecto para citas a domicilio o estudio'
}];
export function Benefits() {
  return <section className="py-24 px-6 bg-white" data-id="element-51">
      <div className="max-w-6xl mx-auto" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-serif text-luxury-black mb-4" data-id="element-54">
            ¿POR QUÉ LO AMARÁS?
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-55"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-56">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-nude-light p-8 rounded-xl border border-nude hover:border-gold/30 transition-colors duration-300 flex flex-col items-center text-center group" data-id="element-57">
              <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center text-gold mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-58">
                {benefit.icon}
              </div>
              <h3 className="text-lg font-sans font-medium text-luxury-black" data-id="element-59">
                {benefit.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}